var validateDirective = angular.module('eficienciaFiscalModule');

var INTEGER_REGEXP = /^-?\d+$/;
validateDirective.directive('integer', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (INTEGER_REGEXP.test(viewValue) || (viewValue == "")) {
                    ctrl.$setValidity('integer', true);
                    return viewValue;
                } else {
                    ctrl.$setValidity('integer', false);
                    return undefined;
                }
            });
        }
    };
});
var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/gm;
validateDirective.directive('date', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {

                var data = viewValue;

                for ($i = 0; $i < data.length; $i++) {
                    if (!/\d/.test(data[$i]) && !(($.inArray($i, [2, 5]) > -1) && data[$i] == '/'))
                        data = data.slice(0, $i) + data.slice($i + 1, data.length);
                }

                if ((data.length >= 3) && (data[2] != "/"))
                    data = data.insert(2, "/");

                if ((data.length >= 6) && (data[5] != "/"))
                    data = data.insert(5, "/");

                if (data.length > 9)
                    data = data.substr(0, 10);


                elm.val(data);

                viewValue = data;

                if (DATE_REGEXP.test(viewValue) || (viewValue == "")) {
                    ctrl.$setValidity('date', true);
                    return viewValue;
                } else {
                    ctrl.$setValidity('date', false);
                    return undefined;
                }
            });
        }
    };
});

var CURRENCY_REGEXP = /^(R\$ |)([1-9]\d{0,2}(\.\d{3})*|([1-9]\d*))(\.\d{2})?$/;
validateDirective.directive('currency', function () {
    var mascaraCurrency = function (ctrl, elm, viewValue) {
        var currency = viewValue;

        currency = currency.replace(/\./g, ',')

        if (currency.length > 0) {
            if (currency[0] != 'R') currency = 'R' + currency;
            if (currency[1] != '$') currency = currency.insert(1, '$');
            if (currency[2] != ' ') currency = currency.insert(2, ' ');
        }

        var decimal = false;
        for ($i = 3; $i < currency.length; $i++) {
            if (!(/\d/.test(currency[$i]) || (currency[$i] == ',' && !decimal && /\d/.test(currency[$i - 1]))))
                currency = currency.slice(0, $i) + currency.slice($i + 1, currency.length);
            if (currency[$i] == ',' && decimal == false) {
                decimal = true;
                currency = currency.substr(0, $i + 3);
            }
        }

        elm.val(currency);
        viewValue = currency.substr(3, currency.length).replace(',', '.');


        if (CURRENCY_REGEXP.test(viewValue) || (viewValue == "")) {
            ctrl.$setValidity('currency', true);
            return viewValue;
        } else {
            ctrl.$setValidity('currency', false);
            return undefined;
        }
    }

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            attrs.$observe('ngModel', function (value) {
                scope.$watch(value, function (val) {
                    if (val != undefined)
                        mascaraCurrency(ctrl, elm, val.toString())
                });
            });
            ctrl.$parsers.unshift(function (viewValue) {
                return mascaraCurrency(ctrl, elm, viewValue)
            });
        }
    };
});

var PERCENT_REGEXP = /^\d+(((\.|,)\d{1,2})|)$/;
validateDirective.directive('percent', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (attrs.percentMin != undefined && viewValue != "" && viewValue < parseFloat(attrs.percentMin.replace(/,/, '.'))) {
                    ctrl.$setValidity('percentmin', false);
                    return viewValue;
                } else {
                    ctrl.$setValidity('percentmin', true);
                    if (attrs.percentMax != undefined && viewValue != "" && viewValue > parseFloat(attrs.percentMax.replace(/,/, '.'))) {
                        ctrl.$setValidity('percentmax', false);
                        return viewValue;
                    } else {
                        ctrl.$setValidity('percentmax', true);
                        return viewValue;
                    }
                }
            });
            ctrl.$parsers.unshift(function (viewValue) {
                if (PERCENT_REGEXP.test(viewValue) || (viewValue == "")) {
                    ctrl.$setValidity('percent', true);
                    return viewValue.replace(/,/g, '.');
                } else {
                    ctrl.$setValidity('percent', false);
                    return undefined;
                }
            });
        }
    };
});

validateDirective.directive('cpf', function () {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function (viewValue) {
                if (validaCPF(viewValue)) {
                    ctrl.$setValidity('cpf', true);
                    return viewValue;
                } else {
                    ctrl.$setValidity('cpf', false);
                    return undefined;
                }
            });
        }
    };
});

function validaCPF(cpf) {
    cpf = cpf.replace('.', '');
    cpf = cpf.replace('.', '');
    cpf = cpf.replace('-', '');
    var Soma;
    var Resto;
    Soma = 0;
    if (cpf == "00000000000") return false;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(cpf.substring(9, 10))) return false;
    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
    if ((Resto == 10) || (Resto == 11)) Resto = 0;
    if (Resto != parseInt(cpf.substring(10, 11))) return false;
    return true;
}
